export default __webpack_public_path__ + "static/media/07.014a87e5.png";